<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">{{project.short_name}} ⇝ Список организаций</h2>
      <div class="flex align-items-center gap-1">
        <button v-if="project_mode !== 'vityaz'" class="compose btn btn-secondary" @click="importRecord()">Secret Button</button>
        <button class="compose btn btn-primary" @click="newRecord()">Добавить</button>
        <button v-if="project_mode !== 'vityaz'" class="compose btn btn-warning" @click="importModal()">Импорт со сборщика данных</button>
      </div>
    </div>

    <div class="card">
      <div class="card-header p-0">
        <div class="d-flex justify-content-between w-100">
          <div class="input-group input-group-merge shadow-none m-0 flex-grow-1">
            <div class="input-group-prepend">
              <span class="input-group-text border-0">
                <font-awesome-icon icon="fas fa-search" />
              </span>
            </div>
            <input type="text" @input="search()" v-model="searchQuery" class="form-control files-filter border-0 bg-transparent" placeholder="Поиск" />
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="user_organizations && user_organizations.length > 0">
      <div class="card-body p-0">
        <h5 class="card-header">Действия других пользователей</h5>
        <div class="table-striped">
          <table class="table">
            <thead>
            <tr>
              <th style="width: 20%;">Пользователь</th>
              <th style="width: 40%;">Наименование</th>
              <th style="width: 40%;">ИНН</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user_organization in user_organizations">
              <td>{{user_organization.user}}</td>
              <td>{{ user_organization.name ? user_organization.name : '-' }}</td>
              <td>{{user_organization.inn}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">
            <thead>
            <tr>
              <th style="width: 5%;">#</th>
              <th style="width: 10%;">Тип</th>
              <th style="width: 40%;">Наименование</th>
              <th style="width: 10%;">ИНН</th>
              <th style="width: 20%;">Сгенерировано</th>
              <th style="width: 15%;">Действия</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="safeOrganizations.length > 0">
              <tr v-for="(organization, index) in safeOrganizations">
                <td>{{index + 1}}</td>
                <td>{{ organization.pack ? organization.pack.name : '-' }}</td>
                <td>{{ organization.name ? organization.name : '-' }}</td>
                <td>{{organization.inn}}</td>
                <td><font-awesome-icon v-if="organization.is_generate" icon="fas fa-check" /></td>
                <td>
                  <div class="btn-group">
                    <a class="btn btn-sm btn-success" @click.prevent="generateDocs(organization.id)" href="#"><font-awesome-icon icon="fas fa-eye" /></a>
                    <a class="btn btn-sm btn-primary" @click.prevent="editRecord(organization)" href="#"><font-awesome-icon icon="fas fa-edit" /></a>
                    <a class="btn btn-sm btn-danger" @click.prevent="deleteRecord(organization.id)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="6">
                  Нет данных для отображения
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>

        <nav class="justify-content-between d-flex mt-2 align-items-center">
          <div class="p-2">
            <label for="inputState" class="form-label mb-0">На странице: </label>
            <select class="form-select" v-model="perPage" @change="changePerPage()">
              <option :value="value" v-for="value in perPageList">{{value}}</option>
            </select>
          </div>
          <ul class="pagination mb-0">
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(firstPage)" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-fast-backward" /> Первая
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="prevPage()" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-step-backward" /> Предыдущая
              </a>
            </li>
            <li class="page-item" :class="{ 'active': page.active }" v-for="page in visiblePages">
              <a class="page-link" @click.prevent="selectPage(page.name)" href="#">{{page.name}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="nextPage()" href="#">
                Следующая <font-awesome-icon class="ml-1" icon="fas fa-step-forward" />
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(lastPage)" href="#">
                Последняя <font-awesome-icon class="ml-1" icon="fas fa-fast-forward" />
              </a>
            </li>
          </ul>
          <div class="p-2">
            <p class="mb-0">(Всего страниц: {{lastPage}})</p>
          </div>
        </nav>

      </div>
    </div>

    <!-- Field Add/Edit Modal -->
    <div class="modal fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-xl">
        <div class="modal-content pt-0">
          <div class="modal-header mb-1">
            <h5 class="modal-title" v-show="!editmode">Добавить</h5>
            <template v-if="editmode">
              <h5 class="modal-title" v-if="recordform.users && recordform.users.length > 0">Совместное редактирование <span class="badge badge-success" v-for="user in recordform.users">{{user.name}}</span> </h5>
              <h5 class="modal-title" v-else>Редактировать</h5>
            </template>
            <button type="button" class="close" @click="closeModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body" v-if="categories.length > 0">
              <div class="form-group">
                <label>Наименование <span v-if="checkName()" style="color: red;">Обнаружено совпадение с пользователем {{duplicateWith}}</span></label>
                <input v-model="recordform.name" @input="sendToAnother()" type="text" placeholder="Наименование" class="form-control" required :class="{ 'is-invalid': checkName() }">
              </div>


              <label>ИНН <span v-if="checkINN()" style="color: red;">Обнаружено совпадение с пользователем {{duplicateWith}}</span></label>
              <div class="input-group mb-1">
                <input v-model="recordform.inn" @input="sendToAnother()" type="text" placeholder="ИНН" class="form-control" required :class="{ 'is-invalid': checkINN() }">
                <div class="input-group-append">
                  <button @click="egrulImport()" class="btn btn-primary waves-effect" type="button" v-show="!egrul_show">EGRUL</button>
                  <button @click="egrul_show = !egrul_show" class="btn btn-danger waves-effect" type="button" v-show="egrul_show">Скрыть</button>
                </div>
              </div>

              <template v-if="egrul_show">
                <p><b>Полное наименование:</b>  {{egrul.full_name}}</p>
                <p><b>Краткое наименование:</b>  {{egrul.short_name}}</p>
                <p><b>Адрес:</b>  {{egrul.address}}</p>
                <p><b>ФИО Руководителя:</b>  {{egrul.management_name}}</p>
                <p><b>Должность Руководителя:</b>  {{egrul.management_post}}</p>
              </template>

              <div class="form-group">
                <label>Выберите тип</label>
                <v-select v-model="recordform.pack_id" label="name" :reduce="pack => pack.id" :options="packs" />
              </div>

              <div class="form-group" v-if="packNumFieldExist">
                <label>{{ packNumFieldName }}</label>
                <input @input="sendToAnother()" v-model="recordform.pack_number" type="text" placeholder="Номер пакета" class="form-control" :disabled="!editmode">
              </div>

              <div class="form-group d-flex">
                <div class="d-flex flex-row align-items-center mr-2">
                  <label class="mr-2 mb-0">Показать все поля</label>
                  <div class="custom-control custom-switch custom-switch-primary">
                    <input type="checkbox" class="custom-control-input" id="showAllFields" v-model="showAllFields" />
                    <label class="custom-control-label" for="showAllFields">
                      <span class="switch-icon-left"><i data-feather="check"></i></span>
                      <span class="switch-icon-right"><i data-feather="x"></i></span>
                    </label>
                  </div>
                </div>
                <div class="d-flex flex-row align-items-center mr-2">
                  <label class="mr-2 mb-0">Журнал ДСП с двумя заключениями</label>
                  <div class="custom-control custom-switch custom-switch-primary">
                    <input type="checkbox" class="custom-control-input" id="variant2" v-model="recordform.variant2" />
                    <label class="custom-control-label" for="variant2">
                      <span class="switch-icon-left"><i data-feather="check"></i></span>
                      <span class="switch-icon-right"><i data-feather="x"></i></span>
                    </label>
                  </div>
                </div>
              </div>

              <section class="modern-horizontal-wizard">
                <div class="bs-stepper wizard-modern">
                  <div class="bs-stepper-header pt-0 px-0" style="flex-wrap: nowrap;">
                    <div class="d-flex align-items-center" v-for="(category, key) in categories" :style="'width:' + 100 / categories.length + '%;'" style="justify-content: space-evenly;">
                      <div class="step" :class="{ 'active': step == key}">
                        <button type="button" class="step-trigger" @click="changeTab(key)">
                          <span class="bs-stepper-box">
                            {{key + 1}}
                          </span>
                          <span class="bs-stepper-label mt-0" style="white-space: normal!important;">
                            <span class="bs-stepper-title">{{category.name}}</span>
                          </span>
                        </button>
                      </div>
                      <div class="line" v-if="categories.length != key + 1">
                        <font-awesome-icon icon="fa-solid fa-angle-right" />
                      </div>
                    </div>
                  </div>
                  <div class="bs-stepper-content" style="background: unset; padding: 0; box-shadow: none;" v-if="selectedFields || showAllFields">
                    <div v-for="(category, key) in categories" class="content" :class="{ 'active': step == key}">

                      <div class="form-group" v-for="field in category.fields" v-show="field.tag != 'PACKAGE_NUMBER'" :key=field.id>
                        <template v-if="showAllFields">
                          <label>{{field.description}}</label>
                          <input @input="sendToAnother()" v-model="recordform.fields[field.id]" type="text" :placeholder="field.name" class="form-control" :disabled="(!field.creationAvailable && !editmode) || (!field.changeAvailable && editmode)">
                        </template>
                        <template v-else>
                          <template v-if="selectedFields.find(item => item === field.id)">
                            <label>{{field.description}}</label>
                            <input @input="sendToAnother()" v-model="recordform.fields[field.id]" type="text" :placeholder="field.name" class="form-control" :disabled="(!field.creationAvailable && !editmode) || (!field.changeAvailable && editmode)">
                          </template>
                        </template>
                      </div>

                    </div>
                  </div>
                </div>
              </section>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal()">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

    <!-- Import Modal -->
    <div class="modal fade" id="importRecordModal" tabindex="-1" role="dialog" aria-hidden="true" data-focus="false"  data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-xl">
        <div class="modal-content pt-0">
          <div class="modal-header mb-1">
            <h5 class="modal-title" v-show="!editmode">Импортировать</h5>
            <button type="button" class="close" @click="closeImportModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="createRecord()">
            <div class="modal-body" v-if="packs.length > 0 && categories.length > 0">
              <div class="form-group">
                <label>Наименование <span v-if="checkName()" style="color: red;">Обнаружено совпадение с пользователем {{duplicateWith}}</span></label>
                <input v-model="recordform.name" @input="sendToAnother()" type="text" placeholder="Наименование" class="form-control" required :class="{ 'is-invalid': checkName() }">
              </div>


              <label>ИНН <span v-if="checkINN()" style="color: red;">Обнаружено совпадение с пользователем {{duplicateWith}}</span></label>
              <div class="input-group mb-1">
                <input v-model="recordform.inn" @input="sendToAnother()" type="text" placeholder="ИНН" class="form-control" required :class="{ 'is-invalid': checkINN() }">
                <div class="input-group-append">
                  <button @click="egrulImport()" class="btn btn-primary waves-effect" type="button" v-show="!egrul_show">EGRUL</button>
                  <button @click="egrul_show = !egrul_show" class="btn btn-danger waves-effect" type="button" v-show="egrul_show">Скрыть</button>
                </div>
              </div>

              <template v-if="egrul_show">
                <p><b>Полное наименование:</b>  {{egrul.full_name}}</p>
                <p><b>Краткое наименование:</b>  {{egrul.short_name}}</p>
                <p><b>Адрес:</b>  {{egrul.address}}</p>
                <p><b>ФИО Руководителя:</b>  {{egrul.management_name}}</p>
                <p><b>Должность Руководителя:</b>  {{egrul.management_post}}</p>
              </template>

              <div class="form-group">
                <label>Выберите тип</label>
                <v-select v-model="recordform.pack_id" label="name" :reduce="pack => pack.id" :options="packs" />
              </div>

              <div class="form-group">
                <label>Поиск данных в Формах</label>

                <v-select label="name" :filterable="false" @input="selectFormId" :reduce="form => form.id" :options="forms" @search="onSearchForms">
                  <template slot="no-options">
                    начните писать для поиска
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }} (Заполнено: {{transformToDate(option.updated_at)}})
                      </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }} (Заполнено: {{transformToDate(option.updated_at)}})
                    </div>
                  </template>
                </v-select>
              </div>

              <div class="form-group" v-if="packNumFieldExist">
                <label>{{ packNumFieldName }}</label>
                <input @input="sendToAnother()" v-model="recordform.pack_number" type="text" placeholder="Номер пакета" class="form-control" :disabled="!editmode">
              </div>

              <div class="form-group d-flex">
                <div class="d-flex flex-row align-items-center mr-2">
                  <label class="mr-2 mb-0">Показать все поля</label>
                  <div class="custom-control custom-switch custom-switch-primary">
                    <input type="checkbox" class="custom-control-input" id="showAllFields" v-model="showAllFields" />
                    <label class="custom-control-label" for="showAllFields">
                      <span class="switch-icon-left"><i data-feather="check"></i></span>
                      <span class="switch-icon-right"><i data-feather="x"></i></span>
                    </label>
                  </div>
                </div>
                <div class="d-flex flex-row align-items-center mr-2">
                  <label class="mr-2 mb-0">Журнал ДСП с двумя заключениями</label>
                  <div class="custom-control custom-switch custom-switch-primary">
                    <input type="checkbox" class="custom-control-input" id="variant2" v-model="recordform.variant2" />
                    <label class="custom-control-label" for="variant2">
                      <span class="switch-icon-left"><i data-feather="check"></i></span>
                      <span class="switch-icon-right"><i data-feather="x"></i></span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12 col-md-2 mb-3" v-for="(presset, key) in pressets" v-if="pressets && pressets.length > 0">
                  <div class="card border basic-pricing h-100">
                    <div class="card-body d-flex flex-column">
                      <h3>{{presset.name}}</h3>

                      <div class="d-flex justify-content-between align-items-center mt-auto">
                        <button @click.prevent="loadPresset(key)" class="btn btn-outline-success"><font-awesome-icon icon="fas fa-eye" /></button>
                        <button @click.prevent="deletePresset(presset.name)" class="btn btn-outline-danger"><font-awesome-icon icon="fas fa-trash" /></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2 mb-3">
                  <div class="card border basic-pricing h-100">
                    <div class="card-body d-flex flex-column">
                      <button @click.prevent="savePreset()" class="btn btn-secondary" type="button" name="button">Сохранить Прессет</button>
                    </div>
                  </div>
                </div>
              </div>

              <section class="modern-horizontal-wizard">
                <div class="bs-stepper wizard-modern">
                  <div class="bs-stepper-header pt-0 px-0" style="flex-wrap: nowrap;">
                    <div class="d-flex align-items-center" v-for="(category, key) in categories" :style="'width:' + 100 / categories.length + '%;'" style="justify-content: space-evenly;">
                      <div class="step" :class="{ 'active': step == key}">
                        <button type="button" class="step-trigger" @click="changeTab(key)">
                          <span class="bs-stepper-box">
                            {{key + 1}}
                          </span>
                          <span class="bs-stepper-label mt-0" style="white-space: normal!important;">
                            <span class="bs-stepper-title">{{category.name}}</span>
                          </span>
                        </button>
                      </div>
                      <div class="line" v-if="categories.length != key + 1">
                        <font-awesome-icon icon="fa-solid fa-angle-right" />
                      </div>
                    </div>
                  </div>
                  <div class="bs-stepper-content" style="background: unset; padding: 0; box-shadow: none;" v-if="selectedFields || showAllFields">
                    <div v-for="(category, key) in categories" class="content" :class="{ 'active': step == key}">
                      <div class="row" v-if="!update">
                        <div class="col-6">
                          <div class="form-group" style="min-height:100px;" v-for="field in renderFields(category.fields)" v-show="field.tag != 'PACKAGE_NUMBER'" :key="field.id">
                            <label>{{field.description}}</label>
                            <input @input="sendToAnother()" v-model="recordform.fields[field.id]" type="text" :placeholder="field.name" class="form-control" :disabled="(!field.creationAvailable && !editmode) || (!field.changeAvailable && editmode)">
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group" style="min-height:100px;" v-for="field in renderFields(category.fields)" v-show="field.tag != 'PACKAGE_NUMBER'" :key="'forms_'+field.id">
                            <label>Поле из форм</label>
                            <v-select @input="fillFromForms($event, field.id)" label="name" :options="formsData" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeImportModal()">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->


    <organization-import
        :projectId="id"
        @orgsUpdate="loadRecords()"
    ></organization-import>
  </div>
</template>

<script>
import Template from "./Template.vue";
import OrganizationImport from "./modal/OrganizationImport.vue";
import moment from "moment";

export default {
  components: {Template, OrganizationImport},
  props: ['id', 'project'],
  computed: {
    safeOrganizations() {
      return Array.isArray(this.organizations)
          ? this.organizations.filter(o => o && typeof o === 'object')
          : [];
    },
    selectedFields() {
      let pack = this.packs.find(pack => {
        return pack.id === this.recordform.pack_id;
      });

      if(pack)
        return pack.fields;

      return null;
    },
    startPage() {
      if (this.currentPage < 4) {
        return 1;
      }
      if (this.currentPage == this.lastPage) {
        return this.startPage2;
      }

      if ((this.currentPage + 1) == this.lastPage) {
        return this.startPage2;
      }

      if ((this.currentPage + 2) == this.lastPage) {
        return this.startPage2;
      }
      return this.currentPage - 3;
    },
    startPage2(){
      if(this.lastPage > 6){
        return this.lastPage - 6;
      }
      if(this.lastPage > 5){
        return this.lastPage - 5;
      }
      if(this.lastPage > 4){
        return this.lastPage - 4;
      }
      if(this.lastPage > 3){
        return this.lastPage - 3;
      }
      if(this.lastPage > 2){
        return this.lastPage - 2;
      }
    },
    visiblePages() {
      let pages = [];
      let start = this.startPage;
      let end = Math.min(this.startPage + 6, this.lastPage);
      for (let i = start; i <= end; i++) {
        pages.push({
          name: i,
          active: i == this.currentPage
        });
      }
      return pages;
    }
  },
  data () {
    return {
      forms: [],
      update: false,
      duplicateWith: null,
      step: 0,
      searchQuery: '',
      currentPage: 1,
      lastPage: 1,
      firstPage: 1,
      timeout: null,
      timeout_2: null,
      timeout_3: null,
      timeout_4: null,
      perPage: 10,
      perPageList: [10, 25, 50, 100],
      categories: [],
      packs: [],
      organizations: [],
      recordform: new Form({
        id: null,
        name: null,
        inn: null,
        pack_id: null,
        pack_number: null,
        fields: [],
        users: [],
        variant2: false,
      }),
      editmode: false,
      user_organizations: [],
      egrul_show: false,
      egrul: {
        address: null,
        management_name: null,
        management_post: null,
        full_name: null,
        short_name: null,
      },
      packNumFieldExist: false,
      packNumFieldName: null,
      showAllFields: false,
      token: '2|tnhfUH2xBeR899A1kamgnzOpClKdlQVbb8cqCwJVc21cd6d2',
      formsData: [],
      pressetForm: [],
      pressets: [],
      project_mode: process.env.MIX_PROJECT_MODE || "uib",
    }
  },
  methods: {
    loadPresset(key){
      this.update = true;
      this.pressets[key].fields.forEach(item => {
        let forms = this.formsData.filter((item2) => item2.name == item.form_field_name);
        console.log(forms)
        if(forms.length > 0)
          this.recordform.fields[item.field_id] = forms[0].value;
      });
      this.update = false;
    },
    deletePresset(name){
      Swal.fire({
        title: 'Вы уверены?',
        text: "Это действие нельзя будет отменить",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Да, удалить',
        cancelButtonText: 'Отмена'
        }).then((result) => {
         if (result.value) {
           let output = [];
           let pressetsData = JSON.parse(window.localStorage.getItem('pressets'));
           pressetsData.forEach(item => {
             if(item.name !== name && item.project !== this.id)
              output.push(item)
           });
           window.localStorage.setItem('pressets', JSON.stringify(output));
           this.pressets = output;
        }
      })
    },
    loadPressets(){
      let pressetsData = JSON.parse(window.localStorage.getItem('pressets'));
      if(pressetsData && pressetsData.length > 0){
        this.pressets = pressetsData.filter((item) => item.project_id == this.id)
      }
    },
    savePreset(){
      Swal.fire({
        title: "Введите наименование пресета",
        input: 'text',
        showCancelButton: true,
        cancelButtonText: 'Отмена',
        confirmButtonText: 'Сохранить'
      }).then((result) => {
        if (result.value) {
          let output = {
            project_id: this.id,
            name: result.value,
            fields: this.pressetForm
          };

          let pressetsData = JSON.parse(window.localStorage.getItem('pressets'));
          if(!pressetsData){
            pressetsData = [];
          }

          pressetsData.push(output);
          window.localStorage.setItem('pressets', JSON.stringify(pressetsData));
          this.pressets.push(output);
        }
      });
    },
    fillFromForms(event, id){
      // v-select может прислать null при очистке выбора
      if (!event) {
        this.update = true;
        this.recordform.fields[id] = null;

        // очищаем связку в пресете
        this.pressetForm = this.pressetForm.filter(item => item.field_id != id);

        this.update = false;
        return;
      }

      if(!this.pressetForm.filter((item) => item.field_id == id).length)
        this.pressetForm.push({field_id: id, form_field_name: event.name});
      else
        this.pressetForm.filter((item) => item.field_id == id)[0].form_field_name = event.name;

      this.update = true;
      this.recordform.fields[id] = event.value;
      this.update = false;
    },
    renderFields(fields){
      let output = [];
      if(this.showAllFields){
        output = fields;
      }else{
        fields.forEach(field => {
          if(this.selectedFields.find(item => item === field.id))
            output.push(field);
        });
      }
      return output;
    },
    transformToDate(date){
      if(!moment(date).isValid()){
        return '-';
      }
      return moment(date).format("DD.MM.YYYY");
    },
    async selectFormId(id){
      await axios.get('https://forms.uibcom.ru/api/links/' + id, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + this.token,
        }
      }).then(response => {
        this.formsData.splice(0)
        let output = [];
        response.data.data.forEach(item => {
          if(item.field.additional_fields && typeof item.value === 'object')
          {
            item.field.additional_fields.forEach((additional_field, additional_field_key) => {
              let value = '';
              item.value.forEach((item_value, item_index) => {
                if(item.value[item_index][additional_field_key]){
                  if(item_index === item.value.length - 1)
                    value += item.value[item_index][additional_field_key]
                  else
                    value += item.value[item_index][additional_field_key] + ', '
                }
              });
              output.push({
                name: item.field.name + ': ' + additional_field,
                value: value
              })
            });
          }
          else
          {
            output.push({
              name: item.field.name,
              value: item.value
            })
          }
        });
        this.formsData = output;
        output.forEach(item => {
          if(item.name.includes('ИНН'))
            this.recordform.inn = item.value
          else if(item.name.includes('Наименование организации: Сокращенное'))
            this.recordform.name = item.value
        });

      })
    },
    onSearchForms(search, loading)
    {
      if(this.timeout_4)
        clearTimeout(this.timeout_4);

      this.timeout_4 = setTimeout(() => {
        if(search.length) {
          loading(true);

          axios.get('https://forms.uibcom.ru/api/links_list?search=' + search, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + this.token,
            }
          }).then(response => {
            this.forms = response.data.data
            loading(false);
          })
        }
      }, 500);
    },
    importRecord(){
      this.editmode = false;
      this.showAllFields = true;
      this.recordform.reset();
      this.categories.forEach(category => {
        category.fields.forEach(field => {
          if(field.default_value){
            this.recordform.fields[field.id] = field.default_value;
          }else{
            this.recordform.fields[field.id] = '';
          }
        });

      });

      $('#importRecordModal').modal('show');
    },
    egrulImport(){
      const regex=/^[0-9]{10}$/;
      if(!regex.test(this.recordform.inn)){
        Toast.fire({
          icon: 'error',
          title: 'Неверный Формат ИНН'
        });

        return;
      }

      axios.post(
          'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party',
          {query: this.recordform.inn},
          {
            headers: {
              Authorization: 'Authorization ' + 'Token 01a017f5a986bcf21e741189176db78919d7d7af'
            }
          })
          .then(({data})=>{
            if(data.suggestions && data.suggestions[0]){
              let find = data.suggestions[0].data;
              this.egrul.address = find.address.unrestricted_value;
              this.egrul.management_name = find.management.name;
              this.egrul.management_post = find.management.post;
              this.egrul.full_name = find.name.full_with_opf;
              this.egrul.short_name = find.name.short_with_opf;

              let management = find.management.name.split(/\s+/);
              let post = null;
              if(find.management.post)
                post = find.management.post.charAt(0).toUpperCase() + find.management.post.slice(1).toLowerCase();

              this.categories[0].fields.forEach((field) => {
                if(this.recordform.fields[field.id])
                  return;

                switch (field.name) {
                  case 'КраткоеНазваниеОрганизации':
                    if(find.name.short_with_opf)
                      this.recordform.fields[field.id] = find.name.short_with_opf.replace(/"(.*?)"/g, '«$1»').toLowerCase();
                    break;
                  case 'ПолноеНазваниеОрганизации':
                    if(find.name.full_with_opf)
                      this.recordform.fields[field.id] = find.name.full_with_opf.replace(/"(.*?)"/g, '«$1»').toLowerCase();
                    break;
                  case 'АдресС':
                    this.recordform.fields[field.id] = find.address.unrestricted_value;
                    break;
                  case 'Адрес':
                    this.recordform.fields[field.id] = (find.address.data.postal_code ? find.address.data.postal_code + ', ' : '') + (find.address.data.region_with_type ? find.address.data.region_with_type + ', ' : '') + (find.address.data.city_with_type ? find.address.data.city_with_type + ', ' : '') + (find.address.data.city_district_with_type ? find.address.data.city_district_with_type + ', ' : '') + (find.address.data.street_with_type ? find.address.data.street_with_type + ', ' : '') + (!find.address.data.house_type || !find.address.data.house ? '' : find.address.data.house_type + ' ' + find.address.data.house) ;
                    break;
                  case 'город':
                    this.recordform.fields[field.id] = (find.address.data.city_type ? find.address.data.city_type + '. ' : '') + (find.address.data.city ? find.address.data.city : '');
                    break;
                  case 'ДолжностьРуководителя':
                    if(post)
                      this.recordform.fields[field.id] = post;
                    break;
                  case 'ДолжностьРуководителяРП':
                    if(post) {
                      switch (post) {
                        case 'Генеральный директор':
                          this.recordform.fields[field.id] = 'Генерального директора';
                          break;
                        case 'Директор':
                          this.recordform.fields[field.id] = 'Директора';
                          break;
                        case 'Начальник':
                          this.recordform.fields[field.id] = 'Начальника';
                          break;
                      }
                    }
                    break;
                  case 'ДолжностьРуководителяДП':
                    if(post) {
                      switch (post) {
                        case 'Генеральный директор':
                          this.recordform.fields[field.id] = 'Генеральному директору';
                          break;
                        case 'Директор':
                          this.recordform.fields[field.id] = 'Директору';
                          break;
                        case 'Начальник':
                          this.recordform.fields[field.id] = 'Начальнику';
                          break;
                      }
                    }
                    break;
                  case 'ПолноеФИОруководителя':
                    this.recordform.fields[field.id] = find.management.name;
                    break;
                  case 'ФИОруководителя':
                    if(management.length > 0)
                      this.recordform.fields[field.id] = `${management[1].slice(0,1)}. ${management[2].slice(0,1)}. ${management[0]}`;
                    break;
                  case 'УважаемыйИО':
                    if(management.length > 0) {
                      if(management[2].substring(management[2].length -1) === 'ч')
                        this.recordform.fields[field.id] = `Уважаемый ${management[1]} ${management[2]}`;
                      else if(management[2].substring(management[2].length -1) === 'а')
                        this.recordform.fields[field.id] = `Уважаемая ${management[1]} ${management[2]}`;
                    }
                    break;
                }
              })

              this.egrul_show = true;
            }
            else {
              Toast.fire({
                icon: 'error',
                title: 'ИНН не найден'
              });
            }
          });

    },
    changeTab(key){
      this.step = key;
    },
    SuccessToast(){
      Toast.fire({
        icon: 'success',
        title: 'Успешно'
      });
    },
    ErrorToast(){
      Toast.fire({
        icon: 'error',
        title: 'Ошибка'
      });
    },
    editRecord(record){
      this.editmode = true;
      this.recordform.reset();
      this.recordform.id = record.id;
      this.recordform.name = record.name;
      this.recordform.inn = record.inn;
      this.recordform.pack_id = record.pack_id;
      this.recordform.pack_number = record.pack_number;
      this.recordform.variant2 = record.journal ? record.journal.variant2 : false;
      let packNum;

      this.categories.forEach(category => {
        category.fields.forEach((field, index) => {
          if(field.tag === 'PACKAGE_NUMBER'){
            this.packNumFieldExist = true;
            this.packNumFieldName = field.name
            packNum = field.id;
          }
          else
            this.recordform.fields[field.id] = '';
        });

      });

      record.organization_answers.forEach(organization_answer => {
        if(organization_answer.field_id === packNum && organization_answer.value != null && organization_answer.value != ''){
          this.recordform.pack_number = organization_answer.value;
        }
        else
          this.recordform.fields[organization_answer.field_id] = organization_answer.value;
      });

      $('#addNewRecord').modal('show');
    },
    newRecord(){
      this.editmode = false;
      this.recordform.reset();
      this.categories.forEach(category => {
        category.fields.forEach(field => {
          if(field.default_value){
            this.recordform.fields[field.id] = field.default_value;
          }else{
            this.recordform.fields[field.id] = '';
          }
        });

      });

      $('#addNewRecord').modal('show');
    },
    importModal() {
      $('#importModal').modal('show');
    },
    nextPage(){
      if(this.currentPage < this.lastPage){
        this.currentPage++;
        this.loadRecords();
      }
    },
    selectPage(number){
      this.currentPage = number;
      this.loadRecords();
    },
    prevPage(){
      if(this.currentPage > 1){
        this.currentPage--;
        this.loadRecords();
      }
    },
    search(){
      if(this.timeout)
        clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.$Progress.start();
        this.currentPage = 1;
        this.loadRecords();
        this.$Progress.finish();
      }, 500);

    },
    changePerPage(){
      this.currentPage = 1;
      this.loadRecords();
    },
    generateDocs(id){
      this.$Progress.start();
      axios.get('/api/project/'+this.id+'/organization/'+id, {responseType: 'arraybuffer'})
          .then((response)=>{
            this.SuccessToast();
            let blob = new Blob([response.data], {
              type: 'application/zip'
            })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'output.zip'
            link.click()
            this.loadRecords();
            this.$Progress.finish();
          })
          .catch(()=>{
            this.ErrorToast();
            this.$Progress.fail();
          })
    },
    createRecord(){
      this.$Progress.start();
      this.recordform.post('/api/project/'+this.id+'/organization')
          .then((response)=>{
            $('#addNewRecord').modal('hide');
            $('#importRecordModal').modal('hide');
            this.SuccessToast();
            this.loadRecords();
            this.recordform.reset();
            this.$Progress.finish();
          })
          .catch(()=>{
            this.ErrorToast();
            this.$Progress.fail();
          })
    },
    updateRecord(){
      this.$Progress.start();
      this.recordform.put('/api/project/'+this.id+'/organization/'+this.recordform.id)
          .then((response) => {
            $('#addNewRecord').modal('hide');
            this.SuccessToast();
            this.loadRecords();
            this.recordform.reset();
            this.$Progress.finish();
          })
          .catch(() => {
            this.ErrorToast();
            this.$Progress.fail();
          });
    },
    deleteRecord(id){
      Swal.fire({
        title: 'Вы уверены?',
        text: "Это действие нельзя будет отменить",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonText: 'Отмена',
        confirmButtonText: 'Да, удалить'
      }).then((result) => {
        if (result.value) {
          this.recordform.delete('/api/project/'+this.id+'/organization/'+id).then(()=>{
            this.SuccessToast();
            this.loadRecords();
          }).catch((data)=> {
            this.ErrorToast();
          });
        }
      })
    },
    loadRecords(){
      axios.get('/api/project/'+this.id+'/organization?page='+this.currentPage+'&search='+this.searchQuery+'&perPage='+this.perPage).then(({ data }) => {
        this.organizations = data.data;
        this.lastPage = data.last_page;
      });
    },
    loadCategories(){
      axios.get('/api/project/'+this.id+'/category_field').then(({ data }) => {
        this.categories = data;
      });
    },
    loadPacks(){
      axios.get('/api/project/'+this.id+'/pack?page=1&search=&perPage=1000').then(({ data }) => {
        this.packs = data.data;
      });
    },
    closeImportModal(){
      this.pressetId = 0;
      this.linkData = [];
      this.formData = [];
      this.fieldResult = [];
      this.organizationId = null;
      this.linkId = null;
      this.organizationSearchResults = [];
      this.formSearchResults = [];
      this.formSearchQuery = null;
      this.organizationSearchQuery = null;
      $('#importRecordModal').modal('hide');
    },
    closeModal(){
      if(!this.editmode){
        window.Echo.private(`organizations`)
            .whisper('endcreating', {
              user: this.$parent.$parent.user
            });
      }else{
        window.Echo.private(`organizations`)
            .whisper('endediting', {
              user: this.$parent.$parent.user
            });
      }
      this.recordform.reset();
      $('#addNewRecord').modal('hide');
    },
    checkINN(){
      let error = false;
      if(!this.editmode){
        if(this.user_organizations && this.user_organizations.length > 0){
          this.user_organizations.forEach(user_organization => {
            if(user_organization.inn !== null && user_organization.inn === this.recordform.inn){
              error = true;
              this.duplicateWith = user_organization.user;
            }
          });

        }
      }
      return error;
    },
    checkName(){
      let error = false;
      if(!this.editmode){
        if(this.user_organizations && this.user_organizations.length > 0){
          this.user_organizations.forEach(user_organization => {
            if(user_organization.name !== null && user_organization.name === this.recordform.name){
              error = true;
              this.duplicateWith = user_organization.user;
            }
          });

        }
      }
      return error;
    },
    sendToAnother(){
      if(!this.editmode){
        if(this.recordform.name || this.recordform.inn){
          if(this.timeout_2)
            clearTimeout(this.timeout_2);

          this.timeout_2 = setTimeout(() => {
            window.Echo.private(`organizations`)
                .whisper('creating', {
                  name: this.recordform.name,
                  inn: this.recordform.inn,
                  user: this.$parent.$parent.user
                });
          }, 500);
        }
      }else{
        if(this.timeout_2)
          clearTimeout(this.timeout_2);

        this.timeout_2 = setTimeout(() => {
          window.Echo.private(`organizations`)
              .whisper('editing', {
                id: this.recordform.id,
                name: this.recordform.name,
                inn: this.recordform.inn,
                user: this.$parent.$parent.user,
                type_id: this.recordform.type_id,
                fields: this.recordform.fields
              });
        }, 500);
      }

    }
  },
  created() {
    this.$Progress.start();
    this.loadRecords();
    this.loadCategories();
    this.loadPacks();
    this.loadPressets();
    window.Echo.private('organizations')
        .listenForWhisper('editing', (e) => {
          if(this.editmode){
            if(this.recordform.id === e.id){
              this.recordform.name = e.name;
              this.recordform.inn = e.inn;
              this.recordform.type_id = e.type_id;
              this.recordform.fields = e.fields;
              let find = false;
              this.recordform.users.forEach(item => {
                if(item.id == e.user.id){
                  find = true;
                }
              });
              if(!find){
                this.recordform.users.push(e.user);
              }
            }
          }
        })
        .listenForWhisper('endediting', (e) => {
          if(this.editmode){
            this.recordform.users.forEach((user, key) => {
              if(user.id === e.user.id){
                this.recordform.users.splice(key, 1);
              }
            });
          }
        })
        .listenForWhisper('creating', (e) => {
          let found = false;
          this.user_organizations.forEach(user_organization => {
            if(user_organization.user.id === e.user.id){
              user_organization.inn = e.inn;
              user_organization.name = e.name;
              found = true;
            }
          });
          if(!found){
            this.user_organizations.push(e);
          }
        })
        .listenForWhisper('endcreating', (e) => {
          this.user_organizations.forEach((user_organization, key) => {
            if(user_organization.user.id === e.user.id){
              this.user_organizations.splice(key, 1);
            }
          });
        })
        .listen('OrganizationUpdated', e => {
          this.organizations.forEach((item, i) => {
            if(item.id === e.organization.id){
              this.organizations[i].id = e.organization.id;
              this.organizations[i].inn = e.organization.inn;
              this.organizations[i].name = e.organization.name;
              this.organizations[i].pack = e.organization.pack;
              this.organizations[i].pack_id = e.organization.pack_id;
              this.organizations[i].organization_answers = e.organization.organization_answers;
            }
          });

          Toast.fire({
            icon: 'success',
            title: 'Обновление данных'
          });
        })
        .listen('OrganizationCreated', e => {
          this.loadRecords();
          Toast.fire({
            icon: 'success',
            title: 'Добавлена новая организация'
          });
        });
    this.$Progress.finish();
  }
}
</script>
